export default "__VITE_ASSET__DzzmziYt__"